export const CALL_TAB_CLEARED_REASON = {
  Rejected: 'rejected',
  Timeout: 'timeout',
  Canceled: 'canceled',
} as const;

export type CallTabClearedReason =
  (typeof CALL_TAB_CLEARED_REASON)[keyof typeof CALL_TAB_CLEARED_REASON];

export const CALL_TAB_SYNC_MESSAGE_TYPE = {
  CallAnswered: 'call-answered',
  CallCleared: 'call-cleared',
  CallEnded: 'call-ended',
} as const;

export type CallTabSyncMessageType =
  (typeof CALL_TAB_SYNC_MESSAGE_TYPE)[keyof typeof CALL_TAB_SYNC_MESSAGE_TYPE];

export interface CallTabSyncMessage {
  type: CallTabSyncMessageType;
  tabId: string;
  userKey: string;
  extension: string;
  sipCallId: string | null;
  reason?: CallTabClearedReason;
  sentAt: number;
}
